import { ROOMS, SERVICES, DISTANCES, MARQUEE_ITEMS, SITE } from "./site";

// Admin > İçerik panelinden düzenlenebilen TÜM metin/liste içeriklerinin varsayılanları.
// Boş bırakılan alanlar için bu değerler kullanılır.

export const DEFAULT_CONTENT = {
  // Genel / iletişim
  site_phone: SITE.phone,
  site_whatsapp: SITE.whatsapp,
  site_address: SITE.address,
  site_address_city: SITE.addressCity,
  site_city: SITE.city,
  site_since: SITE.since,
  site_facebook: SITE.facebook,
  site_instagram: SITE.instagram,
  footer_text:
    "2009'dan bu yana Samsun'da erkek öğrencilere güvenli, huzurlu ve konforlu bir yaşam alanı sunuyoruz.",
  pagehero_label: "Yalı Yurt — Erkek Öğrenci Yurdu",
  marquee_items: MARQUEE_ITEMS.join(", "),

  // Ana sayfa — Hero
  hero_label: `Erkek Öğrenci Yurdu — ${SITE.city}`,
  hero_title_1: "Üniversite hayatınız için",
  hero_title_2: "güvenli ve konforlu",
  hero_title_3: "bir yaşam alanı.",
  hero_sub:
    "Ondokuz Mayıs Üniversitesi'nin hemen girişinde; 7/24 güvenlik, ev yemekleri ve her odada özel banyo ile 2009'dan beri öğrencilerimizin yanındayız.",

  // Ana sayfa — Tanıtım
  intro_label: "Yalı Yurt'a Hoş Geldiniz",
  intro_title: "Sadece bir yurt değil, kendinize ait bir yaşam alanı.",
  intro_text:
    "2009 yılından bu yana Samsun'da erkek öğrencilere hizmet veriyoruz. Üniversite öğrencilerimizin en temel ihtiyacı olan barınmayı; ev konforunda, sakin ve huzurlu bir ortamda sunuyoruz. Deneyimli kadromuz ve sıcak aile ortamımızla rahatınız için tüm imkanları sağlıyoruz.",
  intro_link: "Hikayemizi Okuyun",

  // Ana sayfa — İstatistikler
  stats: [
    { value: "7/24", label: "Güvenlik & Kamera Sistemi" },
    { value: "24 Saat", label: "Kesintisiz Sıcak Su" },
    { value: "1 · 2", label: "Kişilik Oda Seçenekleri" },
    { value: "1 km", label: "OMÜ Kampüsüne Mesafe" },
    { value: "2009", label: "'dan Beri Aynı Özen" },
  ],

  // Ana sayfa — Değerler
  values_label: "Neden Yalı Yurt",
  values_title: "Dört ilke, tek söz",
  values_desc:
    "Güvenlikten konfora, düzenden konuma; bir öğrencinin ihtiyaç duyduğu her şey düşünüldü.",
  values: [
    { no: "01", title: "Güven", desc: "Her kat kameralı sistemle kontrol altında; polis karakolu hemen yanımızda. Güvenlik bizde bir özellik değil, her gün verilen bir sözdür." },
    { no: "02", title: "Konfor", desc: "Her odada özel banyo & WC, mini buzdolabı, 24 saat sıcak su ve merkezi ısınma ile gerçek ev konforu." },
    { no: "03", title: "Düzen", desc: "Düzenli oda temizliği, çamaşır hizmeti ve sakin çalışma ortamıyla öğrencinin hayatını kolaylaştıran bir işleyiş." },
    { no: "04", title: "Konum", desc: "OMÜ kampüsüne 1 km; dolmuş ve otobüs durakları kapımızda, tramvay durağı 100 metre mesafede." },
  ],

  // Ana sayfa — Odalar önizleme
  rooms_label: "Odalarımız",
  rooms_title: "Size uygun odayı bulun",
  rooms_desc:
    "Tek ve iki kişilik oda seçenekleri; her odada özel banyo & WC, mini buzdolabı ve sınırsız internet.",

  // Ana sayfa — İmkanlar önizleme
  services_label: "İmkanlar",
  services_title: "Her şey düşünüldü",
  services_desc:
    "24 saat sıcak sudan ev yemeklerine, çamaşır hizmetinden manzaralı terasa; günlük hayatın her detayı.",

  // Ana sayfa — Galeri / Video önizleme
  gallery_label: "Galeri",
  gallery_title: "Yurda yakından bakın",
  video_label: "Tanıtım Filmi",
  video_title: "Yurdu yakından keşfedin",
  video_desc: "Odalardan ortak alanlara; Yalı Yurt yaşamını kısa filmimizde izleyin.",

  // Ana sayfa — Konum önizleme
  location_label: "Konum",
  location_title: "Şehrin içinde.\nHayata yakın.",
  location_desc:
    "Körfez Mahallesi'nde, Atatürk Bulvarı üzerindeyiz. OMÜ kampüsüne 1 km; toplu taşıma durakları kapımızda, tramvay durağı 100 metre mesafede.",
  home_distances: [
    { place: "Tıp Fakültesi", time: "4 dk" },
    { place: "Siyasal Bilgiler", time: "5 dk" },
    { place: "Fen Edebiyat", time: "9 dk" },
    { place: "Mühendislik", time: "10 dk" },
  ],

  // Ana sayfa — İletişim teaser + foto bandı + final CTA
  contact_teaser_title: "Bize ulaşın.",
  contact_teaser_text:
    "Sorularınız için bizi arayın, WhatsApp'tan yazın veya iletişim formunu doldurun; en kısa sürede dönüş yapalım.",
  photo_break_quote: "Kendinizi rahat hissedeceğiniz bir yaşam alanı.",
  cta_label: "Sınırlı Kontenjan",
  cta_title: "Yeni dönem için\nyerinizi ayırın.",
  cta_text:
    "Kayıtlarımız devam ediyor. Kontenjanlar dolmadan bize ulaşın, yurdumuzu yerinde görün.",

  // Sayfa başlıkları (PageHero)
  ph_odalar_title: "Odalarımız",
  ph_odalar_subtitle: "Size uygun odayı bulun",
  ph_odalar_desc:
    "Tek ve iki kişilik oda seçenekleri. Her odada özel banyo & WC, mini buzdolabı, sınırsız internet ve 24 saat sıcak su standart olarak sunulur.",
  ph_hizmetler_title: "İmkanlar",
  ph_hizmetler_subtitle: "Her şey düşünüldü",
  ph_hizmetler_desc:
    "Güvenlikten yemeğe, temizlikten sosyal alanlara; bir öğrencinin günlük hayatında ihtiyaç duyduğu tüm hizmetler tek çatı altında.",
  ph_galeri_title: "Galeri",
  ph_galeri_subtitle: "Yurda yakından bakın",
  ph_galeri_desc:
    "Odalardan ortak alanlara, yemekhaneden çalışma ortamına; Yalı Yurt yaşamından kareler.",
  ph_videolar_title: "Videolar",
  ph_videolar_subtitle: "Yurdu yakından keşfedin",
  ph_videolar_desc:
    "Odalardan ortak alanlara; Yalı Yurt yaşamını ekranınıza taşıyan tanıtım filmlerimiz çok yakında burada.",
  ph_konum_title: "Konum",
  ph_konum_subtitle: "Şehrin içinde. Hayata yakın.",
  ph_konum_desc:
    "Körfez Mahallesi'nde, Atatürk Bulvarı üzerinde; Ondokuz Mayıs Üniversitesi'nin hemen girişindeyiz.",
  ph_hakkimizda_title: "Hakkımızda",
  ph_hakkimizda_subtitle: "Bir yurttan fazlası; ikinci eviniz",
  ph_hakkimizda_desc:
    "2009 yılından bu yana Samsun'da erkek öğrencilerin güvenli, huzurlu ve konforlu yaşamı için çalışıyoruz.",
  ph_blog_title: "Blog",
  ph_blog_subtitle: "Yurt yaşamından notlar",
  ph_blog_desc: "Samsun'da öğrencilik, yurt yaşamı ve Yalı Yurt'tan haberler.",
  ph_iletisim_title: "İletişim",
  ph_iletisim_subtitle: "Bize ulaşın",
  ph_iletisim_desc:
    "Kayıt, kontenjan ve yurdumuz hakkında tüm sorularınız için bize telefon, WhatsApp veya form aracılığıyla ulaşabilirsiniz.",

  // Odalar sayfası
  odalar_badges: [
    { label: "Her Odada", text: "Özel banyo & WC" },
    { label: "Standart", text: "Mini buzdolabı & internet" },
    { label: "Dahil", text: "Temizlik & 24 saat sıcak su" },
  ],
  rooms: ROOMS.map(({ slug, name, capacity, short, detail, features }) => ({
    slug, name, capacity, short, detail, features,
  })),

  // Hizmetler sayfası
  services: SERVICES,
  hizmet_yemek_label: "Yemekhanemiz",
  hizmet_yemek_title: "Sağlıklı, taze ve lezzetli",
  hizmet_yemek_text:
    "Ev yemekleri anlayışıyla hazırlanan menülerimiz her gün taze olarak sunulur. Kahvaltı hizmetimiz 07:00 – 09:30 saatleri arasında yemekhanemizdedir.",
  hizmet_sosyal_label: "Teras & Sosyal Alanlar",
  hizmet_sosyal_text:
    "En üst katımızda geniş manzaralı teras, bahçeli oturma alanları, ücretsiz spor alanları ve bilardo masası.",

  // Konum sayfası
  map_address: "Körfez Mahallesi Atatürk Bulvarı No:154 Atakum Samsun",
  map_query: "Samsun Yalı Özel Erkek Öğrenci Yurdu",
  map_business_url: "https://share.google/HFON57ZJr0ir2TVmy",
  konum_dist_title: "Ne kadar uzağız?",
  konum_dist_desc:
    "Fakültelere ve şehrin önemli noktalarına mesafemiz; zamanınız size kalsın.",
  distances: DISTANCES,

  // Hakkımızda sayfası
  about_label: "Hikayemiz",
  about_title: "Sıcak aile ortamı, deneyimli kadro",
  about_p1:
    "Alanında uzman, deneyimli ve dinamik kadromuzla hizmet veren Samsun Yalı Öğrenci Yurdu, erkek öğrencilere ev sahipliği yapıyor. Ondokuz Mayıs Üniversitesi'nin hemen girişinde, toplu taşımanın kapımızdan geçtiği bir lokasyonda; güven, huzur ve konforu bir arada sunuyoruz.",
  about_p2:
    "Genç nesle hizmet verdiğimizin farkındayız. Öğrencilerimiz hem ulaşım hem de sosyal ve kültürel yönlerden rahatça faydalanabilsin diye tüm imkanları sağlamayı en büyük kazancımız sayıyoruz.",
  about_values_title: "Neden biz?",
  milestones: [
    { no: "01", title: "2009'dan beri", desc: "Samsun'da erkek öğrencilere hizmet veren köklü bir aile işletmesiyiz. 13 yılı aşkın tecrübemizle kendini ispatlamış bir kadro ile çalışıyoruz." },
    { no: "02", title: "Ev konforu anlayışı", desc: "Barınma ihtiyacını; ev konforunda ve kalitesinde, sakin ve huzurlu bir ortamda karşılayacak bir konsept sunuyoruz." },
    { no: "03", title: "Sürekli yenilenen", desc: "Değişmeyen tek şey değişimin kendisidir. Öğrencilerimizi daha huzurlu ve konforlu nasıl hissettirebiliriz motivasyonuyla sürekli yenileniyoruz." },
    { no: "04", title: "Büyük bir aile", desc: "Öğrencilerimiz üniversitenin ilk yıllarından mezuniyetine kadar büyük ailemizin içinde yer alır; talep ve önerilerine her zaman değer veririz." },
  ],

  // Videolar sayfası
  videos: [
    { title: "Yalı Yurt Tanıtım Filmi", url: "https://www.instagram.com/p/DcNvwIiAGpB/" },
  ],
  video_soon_text:
    "Tanıtım filmimiz şu anda hazırlanıyor. Yurdu yerinde görmek ve tüm sorularınız için bize WhatsApp'tan ulaşabilirsiniz.",

  // İletişim sayfası
  contact_form_title: "Sizi arayalım",
  contact_form_text: "Formu doldurun, en kısa sürede size dönüş yapalım.",
  randevu_title: "Yerinde görüşme randevusu",
  randevu_text: "Yurdu gelip yerinde görün; gün ve saat aralığı seçin.",
  time_slots: "10:00 - 12:00, 13:00 - 15:00, 15:00 - 17:00, 17:00 - 19:00",
};

export const slugify = (s) =>
  (s || "oda")
    .toLowerCase()
    .replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ş/g, "s")
    .replace(/ı/g, "i").replace(/ö/g, "o").replace(/ç/g, "c")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const ytId = (url) => {
  const m = (url || "").match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/
  );
  return m ? m[1] : null;
};

export const igId = (url) => {
  const m = (url || "").match(/instagram\.com\/(?:p|reel|reels)\/([\w-]+)/);
  return m ? m[1] : null;
};
